
<div :data-component-name="$options.name" class="h-100">
  <div class="w-100 h-100 div_general">
    <b-row
      class="w-100 h-100 d-flex position-relative offre_special_container hauteurImageMobile"
    >
      <b-col cols="8" class="h-25 mt-2">
        <div v-if="content.petiteNote" class="boite_petite_note">
          <span class="petite_note graphik_bold" v-html="content.petiteNote"> </span>
        </div>
      </b-col>
      <b-col
        class="d-flex flex-column align-items-center align-items-md-start py-1 py-md-0 py-sm-0 justify-content-center position-static col-12 col-md-4 barreDessousMobile mobile_text_center"
        :style="styleObject"
      >
        <span
          v-if="content.idJeu != null"
          :class="['progressif ' + content.tailleProgressif + ' ' + content.idJeu]"
        ></span>
        <div>
          <div
            v-if="content.surTitre"
            class="offre_surtitre graphik_bold"
            v-html="content.surTitre"
          ></div>
          <h3
            v-if="content.titre"
            class="titre graphik_bold pt-0 pb-1"
            v-html="content.titre"
          ></h3>
        </div>
        <div
          v-if="content.sousTitre"
          class="sousTitre pb-3 pt-0 mt-1"
          v-html="content.sousTitre"
        ></div>

        <button
          v-if="content.texteBouton"
          class="btn graphik_bold mb-0 mt-1"
          :style="[
            { 'background-color': content.colorBtn },
            { 'border-color': content.borderColor },
          ]"
        >
          {{ content.texteBouton }}
        </button>
      </b-col>
    </b-row>
  </div>
</div>
